<script>
import { mapState } from 'vuex';
import Vue from 'vue';

export default {
  name: 'SkiSchoolLevel',
  props: {
    level: {
      type: Object,
      required: true,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      levelItem: Object.assign({}, this.level),
    };
  },
  computed: {
    ...mapState({
      selectedDomainId: state => state.ski.selectedDomainId,
    }),
  },
  watch: {
    level: {
      deep: true,
      handler() {
        this.levelItem = Object.assign({}, this.level);
      },
    },
    selectedDomainId() {
      this.setupDomains();
    },
  },
  created() {
    this.setupDomains();
  },
  methods: {
    onLevelChange(params) {
      this.$emit('onLevelChange', {
        levelItem: this.levelItem,
        params,
      });
      if (params.priority) {
        this.$nextTick(() => {
          const element = 'priority'.concat(this.levelItem.priority);
          this.$refs[element].focus();
        });
      }
    },
    setupDomains() {
      if (this.selectedDomainId !== null) {
        this.levelItem.domains = this.levelItem.domains || Vue.set(this.levelItem, 'domains', {});
        if (!this.levelItem.domains[this.selectedDomainId]) {
          Vue.set(this.levelItem.domains, this.selectedDomainId, {
            domainId: this.selectedDomainId,
            name: '',
          });
        }
      }
    },
  },
};
</script>

<template>
  <v-container class="pa-0">
    <v-layout wrap>
      <v-flex class="text-xs-right pr-4 pt-3" sm1 xs12>
        <h3 :class="{'red--text': !levelItem.id}">
          {{ levelItem.id ? '#' + levelItem.id : $t('buttons.new') }}
        </h3>
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-model="levelItem.externalName"
          :placeholder="$t('ski.skiLevel.nameSupplier')"
          :disabled="saveLoading"
          solo
          @input="onLevelChange({ nameSupplier: $event })"
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-model="levelItem.name"
          :disabled="saveLoading"
          placeholder="Global Name"
          solo
          @input="onLevelChange({ nameWeb: $event })"
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          v-if="selectedDomainId"
          v-model="levelItem.domains[selectedDomainId].name"
          :disabled="saveLoading"
          placeholder="Domain Name"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          v-model="levelItem.priority"
          :placeholder="$t('ski.skiLevel.priority')"
          :disabled="saveLoading"
          :ref="'priority' + levelItem.priority"
          type="Number"
          max="99"
          min="0"
          solo
          @input="onLevelChange({ priority: $event })"
        />
      </v-flex>
      <v-flex sm1 xs12 class="pl-2 pt-0">
        <v-btn
          :disabled="saveLoading"
          class="mb-2"
          color="green"
          small
          outline
          @click="$emit('createOrUpdate', levelItem)"
        >
          {{ level.id ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      </v-flex>
      <v-flex sm1 xs12 class="pl-4 pt-0">
        <v-btn
          :disabled="saveLoading"
          :color="level.id ? 'error' : 'warning'"
          class="mb-2"
          small
          outline
          @click="$emit('remove', level.id)"
        >
          {{ level.id ? $t('buttons.remove') : $t('buttons.cancel') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/school/SkiSchoolLevel.vue